import { deserialise, serialise } from 'kitsu-core'
import { getRequest, postRequest, patchRequest, deleteRequest } from '@/plugins/api-axios'
import { getURL, getRequestHeaders, projectBaseUrl } from '@/utils/axios'

export async function getHseContacts(projectId: string) {
    let { data } = await getRequest(
        getURL({
            path: `projects/${projectId}?include=hseContacts.user&fields[project]=`,
            base: projectBaseUrl,
        }),
        getRequestHeaders('GET')
    )

    let contacts = {
        data: data.included.filter((item) => item.type === 'hseContact'),
        included: data.included.filter((item) => item.type !== 'hseContact'),
    }

    return deserialise(contacts).data.sort((a, b) => {
        return a.index - b.index
    })
}

export async function postHseContactsWithUser(projectId: string, userId: string) {
    let payload = serialise('hseContact', {
        type: 'hseContact',
        project: {
            data: {
                id: projectId,
                type: 'project',
            },
        },
        user: {
            data: {
                id: userId,
                type: 'user',
            },
        },
    })

    let { data } = await postRequest(
        getURL({
            path: `hseContacts?include=user`,
            base: projectBaseUrl,
        }),
        getRequestHeaders('POST'),
        payload.data
    )

    return data.data ? deserialise(data).data : data
}

export async function deleteHseContact(hseContactId: string) {
    let { data } = await deleteRequest(
        getURL({
            path: `hseContacts/${hseContactId}`,
            base: projectBaseUrl,
        }),
        getRequestHeaders('DELETE')
    )

    return data
}

export async function deleteHseDocument(hseDocumentId: string) {
    let { data } = await deleteRequest(
        getURL({
            path: `hseDocuments/${hseDocumentId}`,
            base: projectBaseUrl,
        }),
        getRequestHeaders('DELETE')
    )

    return data
}

export async function getHseDocument(hseDocumentId: string) {
    let { data } = await getRequest(
        getURL({
            path: `hseDocuments/${hseDocumentId}`,
            base: projectBaseUrl,
        }),
        getRequestHeaders('GET')
    )

    return data
}
